
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import { Col } from '../../../base/Grid';

export const DisclaimerColStyled = styled(Col)`
  padding-top: ${rem(16)};
  padding-bottom: ${rem(16)};
`;

export const DisclaimerSectionStyled = styled.section`
    padding-top: ${rem(16)};
    padding-bottom: ${rem(16)};
    border-top: 1px solid #979797;
    border-bottom: 1px solid #979797;
    margin-top: ${rem(32)};
`;
